module.exports = __webpack_public_path__ + "img/event.d34f8b2e.jpg";